import { RiyalImgBLK } from "../../../components/common/RiyalImg";

export default function PaymentTbl({ orderId, orderType, orderCreated, orderAmount, orderDetails, allServicesCategories, moment, t, i18n }) {

    return (
        <>

            <tr>
                <td className="col" > {`${moment(orderCreated).format('YY')}${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 3 }).format(orderId,)}`}</td>
                <td className="col-2">
                    {moment(orderCreated).format('DD-MM-YYYY')}</td>
                <td className="col-5">{orderType === "services" ? t("Service") : t("Book")}
                    <br />
                    {orderType === "services" ?
                        (<span className="text-info">
                            {allServicesCategories.map(cat => cat.en === orderDetails[0].service ?
                                (i18n.language === "ar" ? cat.ar : cat.en) : "")}</span>) : ""}

                </td>
                <td className="col">{orderAmount}  <RiyalImgBLK />
                </td>

            </tr>

        </>
    );

}